import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';

export default function WhereView({ data }: { data: any }) {
  const title = data?.contentInfo?.['section-where']?.title || '';
  const cards = data?.contentInfo?.['section-where']?.cards || [];
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.cardsContainer}>
        {cards.map((card: { imgPath: string; title: string; bodyText: string[] }) => (
          <div className={styles.card} key={card.title}>
            <div className={styles.cardHeader}>
              <div className={styles.iconWrapper}>
                <Image src={card.imgPath} alt={card.title} width={48} height={48} />
              </div>
              <h3 className={styles.cardTitle}>{card.title}</h3>
            </div>
            {card.bodyText?.map((text: string, index: number) => (
              <p className={styles.cardDesc} key={index}>
                {text}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
